import { SET_HARD_DATA } from './types';

export const destroyCache = (_caches) => (dispatch, getState) => {
  const caches = !_caches ? null : Array.isArray(_caches) ? _caches : [_caches];
  const curData = getState().data;

  const newData = Object.fromEntries(
    Object.entries(curData).filter(([k]) => {
      if (!k.includes('http')) return true;
      if (!caches) return false;
      return !caches.some(c => k.includes(c));
    })
  );

  // Only dispatch if the state actually changed
  const changed =
    Object.keys(curData).length !== Object.keys(newData).length ||
    Object.entries(curData).some(([k, v]) => newData[k] !== v);

  if (!changed) return;

  dispatch({ type: SET_HARD_DATA, data: newData });
};

// Cached /realm-photos list responses (see useAssessmentRealmPhotos). Single-photo
// keys (`realm-photos{id}?`) don't match, so only the lists are dropped.
export const destroyRealmPhotosCache = () => destroyCache('realm-photos?');
